import api from "../lib/axios";

const BASE_URL = "/EquipmentCertificate";

export const equipmentCertificateService = {
  getAll: async (params) => {
    const response = await api.get(`${BASE_URL}`, { params });
    return response.data;
  },
 async getAllSearchAsync(params, signal) {
    const response = await api.get(`${BASE_URL}/search`, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`${BASE_URL}/get-by-id/${id}`);
    return response.data;
  },
   edit: async (id) => {
    const response = await api.get(`${BASE_URL}/edit/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(`${BASE_URL}`, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};